import type React from 'react'
import type { IconProps } from '../icons/types'
import { cn } from '../lib/cva'

interface HighlightedIconProps {
	icon: React.FC<IconProps>
	className?: string
}

export const HighlightedIcon: React.FC<HighlightedIconProps> = ({ icon: Icon, className }) => {
	return (
		<div className='p-4 rounded-lg bg-neutral-50'>
			<Icon size={24} className={cn('fill-primary-600', className)} />
		</div>
	)
}
